module.exports = __webpack_public_path__ + "media/src/images/mails/google_plus-f89044d633bfa928ceadf574c83029b0.png";